module.exports = __webpack_public_path__ + "static/media/16.670f43c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/16.jpg
// module id = 191
// module chunks = 0